import React from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { commonLocalization, formattedCurrency, number } from "localization";
import { scaleBand, scaleLinear } from "d3-scale";
import XYAxis from "./axis/xy-axis";
import Grid from "./grid/grid";
import Bar from "./bar/bar";

const getData = (totalWards, data) => {
  const initialBarData = [];
  const barData = [];

  for (let i = 1; i <= totalWards; i += 1) {
    // for bar transition, initial ward value needs to be 0.
    initialBarData.push({
      ward: i,
      value: 0
    });
    // check if data contains all wards from 1 to totalWards, if not then assign 0
    const x = data.find(d => i === parseInt(d.ward, 10));
    if (x) {
      barData.push({
        ward: parseInt(x.ward, 10),
        value: x.value
        // formatted: x.formatted,
      });
    } else {
      barData.push({
        ward: i,
        value: 0
      });
    }
  }
  return {
    barData,
    initialBarData
  };
};
class BarChart extends React.Component {
  constructor() {
    super();
    this.state = {
      tooltipData: {
        left: 0,
        bottom: 0,
        data: {}
      },
      parentWidth: 0
    };
    this.ref = React.createRef();
  }
  componentDidMount() {
    this.fitParentContainer();
    window.addEventListener("resize", this.fitParentContainer);
  }
  fitParentContainer = () => {
    const { parentWidth } = this.state;

    const currentParentWidth =
      this.ref.current && this.ref.current.getBoundingClientRect().width;

    const shouldResize = parentWidth !== currentParentWidth;
    if (shouldResize) {
      this.setState({
        parentWidth: currentParentWidth
      });
    }
  };
  handleTooltip = tooltipData => {
    this.setState({ tooltipData });
  };
  clickToView = ward => {
    const { selectedLanguage } = this.props;
    if (selectedLanguage === "np") {
      return (
        <span>
          <strong>वडा {number(ward)}</strong> हेर्नका लागि थिच्नुस ।
        </span>
      );
    }
    return (
      <span>
        Click to view <strong>Ward {number(ward)}</strong>
      </span>
    );
  };

  render() {
    const { data, selectedLanguage, selectedDropDown, totalWards } = this.props;
    const { tooltipData, parentWidth } = this.state;

    if (parentWidth === 0) {
      return <div ref={this.ref} />;
    }

    const { nrs, projects } = commonLocalization[selectedLanguage];

    // set the dimensions and margins of the graph
    const margin = {
      top: 10,
      right: 10,
      bottom: 20,
      left: 62
    };

    const { barData, initialBarData } = getData(totalWards, data);

    const width = parentWidth - margin.left - margin.right;
    const height = parentWidth * 0.3 - margin.top - margin.bottom;

    const xScale = scaleBand()
      .domain(barData.map(d => d.ward))
      .range([0, width])
      .padding(0.26);

    const yScale = scaleLinear()
      .domain([0, Math.max(...barData.map(d => d.value))])
      .range([height, 0])
      .nice();

    return (
      <BarWrapper
        innerRef={this.ref}
        className="lower-chart"
        margin={margin}
        xScale={xScale}
        tooltipData={tooltipData}
      >
        <div className="tooltip">
          <div className="tooltip-arrow bottom" />
          <div>
            <span className="total-count">
              {selectedDropDown === "budget"
                ? formattedCurrency(tooltipData.data.value)
                : number(tooltipData.data.value)}
            </span>
            <span className="title">
              {selectedDropDown === "budget" ? nrs : projects}
            </span>
            <div className="view-map-detail">
              {this.clickToView(tooltipData.data.ward)}
            </div>
          </div>
        </div>
        <svg
          width={width + margin.left + margin.right}
          height={height + margin.top + margin.bottom}
        >
          <g transform={`translate(${margin.left}, ${margin.top})`}>
            <XYAxis {...{ xScale, yScale, height }} />
            <Grid {...{ xScale, yScale, width }} />
            <Bar
              {...{
                xScale,
                yScale,
                width,
                height,
                barData,
                initialBarData,
                onMouseEnter: this.handleTooltip
              }}
            />
          </g>
        </svg>
      </BarWrapper>
    );
  }
}

const BarWrapper = styled.div`
  position: relative;
  .tooltip {
    position: absolute;
    visibility: ${props =>
      props.tooltipData.left === 0 ? "hidden" : "visible"};
    left: ${props => `${props.tooltipData.left + props.margin.left}px`};
    bottom: ${props =>
      `${props.tooltipData.bottom + props.margin.bottom + 15}px`};
    transform: ${props =>
      `translateX(calc(-50% + ${props.xScale.bandwidth() * 0.5}px))`};
  }
  /* ******** grid ************ */
  .grid-group line {
    stroke: #5d636d;
    stroke-opacity: 0.2;
    shape-rendering: crispEdges;
  }
  .grid-group path {
    stroke-width: 0;
  }
  /* *********** axis  *********** */
  .axis-group path,
  .axis-group line {
    stroke-width: 0;
  }
  .left-axis text {
    fill: #ffffff;
    opacity: 0.2;
    font-size: 12px;
  }
  .bottom-axis text {
    fill: #ffffff;
    opacity: 0.5;
    font-size: 14px;
  }
`;

export default connect(state => ({
  selectedLanguage: state.localizationReducers.selectedLanguage
}))(BarChart);



// WEBPACK FOOTER //
// ./src/components/visualization/bar-chart/bar-chart.js